import React from 'react';
import {
    RadioComponentSelector,
    RadioComponentLabels,
    RadioSvg,
} from './RadioButton.styled';
import { BASE_TEXT_PX } from '../../../styles/fonts/MCFontConstants';

const getRadioIcon = (isChecked, disabled) => {
    const RadioButtonActive = require('src/assets/images/RadioButton.svg');
    const RadioButtonDisabled = require('src/assets/images/RadioButtonDisabled.svg');
    const RadioButtonInactive = require('src/assets/images/RadioButtonInactive.svg');
    if (isChecked && disabled) return RadioButtonDisabled.default || RadioButtonDisabled;
    if (isChecked && !disabled) return RadioButtonActive.default || RadioButtonActive;
    return RadioButtonInactive.default || RadioButtonInactive;
};

const RadioButton = ({
    isChecked,
    label,
    handleChange,
    value,
    fontFamilyStyle,
    containerStyle,
    disabled,
    iPadPaddingRight,
    color,
    padding,
    radioComponentAlignItem,
    radioLabelAlignItem,
    radioBtnMarginTop,
    paddingRight,
    id,
    noWrap
}) => (
    <RadioComponentSelector
        style={{
            ...containerStyle,
            cursor: disabled ? 'not-allowed' : 'pointer',
            // pointerEvents: disabled && 'none',
        }}
        onClick={() => !disabled && handleChange(value)}
        disabled={disabled}
        iPadPaddingRight={iPadPaddingRight}
        radioComponentAlignItem={radioComponentAlignItem}
        paddingRight={paddingRight}
        data-testid="radio-selector"
        id={id}
    >
        <RadioComponentLabels
            noWrap = {noWrap}
            fontSize={BASE_TEXT_PX}
            fontFamilyStyle={fontFamilyStyle}
            color={color}
            disabled = {disabled}
            padding={padding}
            radioLabelAlignItem={radioLabelAlignItem}
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                // pointerEvents: disabled && 'none',
            }}
        >
            <RadioSvg
                src={getRadioIcon(isChecked, disabled)}
                alt="radio"
                width="auto"
                height="auto"
                disabled = {disabled}
                marginTop={radioBtnMarginTop}
                 style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                // pointerEvents: disabled && 'none',
            }}
            />
            {label && <>{label}</>}
        </RadioComponentLabels>
    </RadioComponentSelector>
);

export default RadioButton;